export default {
    init() {
        // JavaScript to be fired on the direct debit form page
        let formFieldDateDay = $('.gfield_date_day').find('input');
        let formFieldDateMonth = $('.gfield_date_month').find('input');
        let formFieldDateYear = $('.gfield_date_year').find('input');

        let preferredPaymentDateField = $('.ed-preferred-payment-date-field');
        let preferredPaymentDateFieldInput = preferredPaymentDateField.find('input');

        $(document).on('change', preferredPaymentDateFieldInput, function(){
            let radiovalue = preferredPaymentDateField.find('input:checked').val();
            let now = new Date();
            let minimumFirstDate = new Date(now);
            minimumFirstDate.setDate(minimumFirstDate.getDate() + 14);

            let dateOfFirstPayment = new Date(minimumFirstDate.getFullYear(), minimumFirstDate.getMonth() + 1, 1);
            if(radiovalue === "15th of month") {
                let month = minimumFirstDate.getMonth();
                // accounting for different month lengths?
                // e.g 15/16 for 31 days, 15/15 for 30 days, 15/14 for 29 days, 15/13 for 28 days
                if(minimumFirstDate.getDate() >= 13) {
                    month = minimumFirstDate.getMonth() + 1;
                }
                dateOfFirstPayment = new Date(minimumFirstDate.getFullYear(), month, 15);
            }

            formFieldDateDay.val(dateOfFirstPayment.getDate());
            formFieldDateMonth.val(dateOfFirstPayment.getMonth()+1);
            formFieldDateYear.val(dateOfFirstPayment.getFullYear());

            $('.first-payment-date-string').remove();
            preferredPaymentDateField.append('<label class="gfield_label first-payment-date-string">First payment date: ' + formFieldDateDay.val() + '/' + formFieldDateMonth.val() + '/' + formFieldDateYear.val() + '</label>');
        });
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/directdebit.js